export default __webpack_public_path__ + "static/media/category_be.4a42a786.svg";